export default class DocumentPolicy {
    static browse(user) {
        return user.hasPermissionTo('browse:documents');
    }

    static read(user, document) {
        if (document.deleted_at !== null) {
            return user.hasPermissionTo('admin');
        }

        return user.hasPermissionTo('read:documents');
    }

    static edit(user, document) {
        return document.deleted_at === null
            && !document.is_archived
            && user.interactsWithQueue(document.activity && document.activity.queue)
            && user.hasPermissionTo('edit:documents');
    }

    static archive(user, document) {
        return DocumentPolicy.edit(user, document);
    }

    static unarchive(user, document) {
        return document.deleted_at === null
            && document.is_archived
            && user.interactsWithQueue(document.activity && document.activity.queue)
            && user.hasPermissionTo('edit:documents');
    }

    static add(user) {
        return user.hasPermissionTo('add:documents');
    }

    static destroy(user, document) {
        return document.deleted_at === null
            && user.interactsWithQueue(document.activity && document.activity.queue)
            && user.hasPermissionTo('delete:documents');
    }

    static purge(user, document) {
        return document.deleted_at !== null
            && user.interactsWithQueue(document.activity && document.activity.queue)
            && user.hasPermissionTo('admin');
    }

    static restore(user, document) {
        return document.deleted_at !== null
            && user.interactsWithQueue(document.activity && document.activity.queue)
            && user.hasPermissionTo('delete:documents');
    }
}
